import "../../../css/installers-view.scss"
import React, {useEffect, useState} from "react";
import ModuleVersionElement from "./ModuleVersionElement.js";
import {UserUtils} from "../../../utils/UserUtils.js";
import {VersionUtils} from "../../../utils/VersionUtils.js";

export default function InstallersView({setInstallersViewOpen, installedModules})
{
    const [installersList, setInstallersList] = useState([]);
    const [refreshingInstallers, setRefreshingInstallers] = useState(false);
    const [loading, setLoading] = useState(true);
    const [selectedInstaller, setSelectedInstaller] = useState(null);
    const [selectedModuleSource, setSelectedModuleSource] = useState(null);
    const [showIncompatibilityMessage, setShowIncompatibilityMessage] = useState(false)
    const [showInstabilityMessage, setShowInstabilityMessage] = useState(false)

    function refreshInstallers()
    {
        setRefreshingInstallers(true);
        fetch("admin/api/refresh-installers", { credentials: "include", method: "POST" })
            .then(res =>
            {
                if(res.ok) window.location.reload();
                else
                {
                    console.error("Failed to refresh installers! - " + res.statusCode + " - " + res.statusText);
                    alert("Failed to refresh installers! - " + res.statusCode + " - " + res.statusText);
                }
            })
            .catch(e =>
            {
                console.error("Failed to refresh installers! - " + e)
                alert("Failed to refresh installers! - " + e);
            })
            .finally(() => setRefreshingInstallers(false));
    }

    useEffect(() =>
    {
        fetch("admin/api/get-module-installers", { credentials: "include" })
            .then(res => res.ok ? res.json() : [])
            .then((data) =>
            {
                setInstallersList(data);
                setLoading(false);
            });
    }, []);

    useEffect(() =>
    {
        const anyInstabilities = selectedModuleSource != null &&
            selectedModuleSource.versions != null &&
            selectedModuleSource.versions.some(ver => ver.compatibleForgeVersion !== UserUtils.getVersion());

        const anyIncompatibles = selectedModuleSource != null &&
            selectedModuleSource.versions != null &&
            selectedModuleSource.versions.some(ver => VersionUtils.hasMajorOrMinorDifference(UserUtils.getVersion(), ver.compatibleForgeVersion));

        setShowIncompatibilityMessage(anyIncompatibles);
        setShowInstabilityMessage(anyInstabilities);
    }, [selectedModuleSource]);


    return (
        <div className="installers-view">
            <div className="installers-area">
                <div className="installers-list">
                    { loading && (
                        <div className="loading-circle"></div>
                    )}
                    {
                        installersList.map(installer => (
                            <div
                                key={installer.installerId}
                                onClick={() => setSelectedInstaller(installer)}
                                className={"installer-item" + (selectedInstaller?.installerId === installer.installerId ? " selected" : "")}
                            >
                                <span>{installer.installerId}</span>
                            </div>
                        ))
                    }
                </div>
                <div className="installers-view-buttons">
                    <div className="installers-view-button" onClick={() => setInstallersViewOpen(false)}>Close</div>
                    <div className={"installers-view-button" + (refreshingInstallers ? " disabled" : "")} onClick={() => refreshInstallers()}>
                        Refresh
                        <div className="loading-circle"></div>
                    </div>
                </div>
            </div>
            <div className="modules-area">
                <div className="modules-area-header">
                    <div className="mah-name">Module Name</div>
                    <div className="mah-ver">Latest Ver</div>
                </div>
                <div className="modules-area-list">
                    {
                        ( selectedInstaller != null && selectedInstaller.moduleSources != null ) && selectedInstaller.moduleSources.map(source =>
                        (
                            <div className={"module-source" + (selectedModuleSource === source ? " selected" : "")} onClick={() => setSelectedModuleSource(source)}>
                                <div title={source.moduleId} className="mah-name">{source.moduleName}</div>
                                <div className="mah-ver">{source.versions && source.versions.length > 0 ? source.versions[0].version : "N/A" }</div>
                            </div>
                        ))
                    }
                </div>
            </div>
            <div className="versions-area">
                <div className="versions-area-header">
                    <div className="version-header-item">Version</div>
                    <div className="version-header-item">API Ver</div>
                    <div className="version-header-item">Released</div>
                </div>
                <div className="versions-area-list">
                    {
                        (selectedModuleSource != null && selectedModuleSource.versions != null) && selectedModuleSource.versions.map(version =>
                        {
                            const matchingInstalledModule = installedModules.find(mod => mod.moduleId === selectedModuleSource.moduleId);

                            return (
                            <ModuleVersionElement
                                key={`${selectedModuleSource.moduleId}-${version.version}-${version.compatibleForgeVersion}`}
                                moduleVersion={version}
                                installerId={selectedInstaller.installerId}
                                moduleSource={selectedModuleSource}
                                installedVersion={matchingInstalledModule?.moduleVersion}
                            />
                        )})
                    }
                </div>
                {
                    showIncompatibilityMessage && (<h5 className="error">* Incompatible with current API version {UserUtils.getVersion()}</h5>)
                }
                {
                    showInstabilityMessage && (<h5 className="warning">* Possible instability with API version {UserUtils.getVersion()}</h5>)
                }
            </div>
        </div>
    );
}